"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityPrinter = function SvgAmenityPrinter(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M977.6 396.8c-22.4-22.4-54.4-35.2-86.4-35.2h-76.8V0H216v361.6h-86.4c-67.2 0-118.4 51.2-118.4 118.4v233.6c0 67.2 51.2 118.4 118.4 118.4H216v192h601.6V825.6h76.8c67.2 0 118.4-51.2 118.4-118.4V473.6c-3.2-25.6-12.8-54.4-35.2-76.8zM270.4 57.6H760v304H270.4v-304zM760 768v198.4H270.4v-304H760V768zm195.2-57.6c0 35.2-25.6 60.8-60.8 60.8h-76.8V608H216v163.2h-86.4c-35.2 0-60.8-25.6-60.8-60.8V476.8c0-32 25.6-60.8 60.8-60.8h764.8c35.2 0 60.8 25.6 60.8 60.8v233.6zM712 761.6H324.8v-48H712v48zm0 83.2H324.8v-48H712v48zm-185.6 80H324.8v-48h201.6v48z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityPrinter, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;